<div class="file-selection-popup">
	<div class="file-selection-header">
		<div class="file-selection-title"><img src="../../../../assets/images/protus.svg" alt="protus" /> {{
			data?.details?.name}}</div>
		<button class="close-btn" mat-dialog-close>×</button>
	</div>
	<div class="content">
			<div class="file-drop-wrapper">
				<span>
					<img src="../../../../assets/images/incident-report-upload-icon.svg" matTooltip="Upload data"
						(click)="fileUpload?.click()" alt="Upload" class="cursor">
				</span>
				<span width="100%" class="upload-text d-flex gap-1" [ngClass]="{'width-18' : file?.name?.length > 30}"
					*ngIf="file!==null">
					<a class="file-name" [matTooltip]="file?.name">{{file?.name}}</a>
					<em class="fas fa-trash-alt cursor" (click)="file=null;fileUpload.value = ''"></em>
				</span>
				<input id="uploadCaptureInputFile" #fileUpload type="file" style="display: none;" (change)="uploadFile($event)"
					[accept]="acceptTypes">
				<span class="upload-link" (click)="fileUpload?.click()" *ngIf="file === null" style="width: 100%;">
					<a class="cursor ml-2 upload-incident">Upload Incident Report*</a>
					<a class="cursor ml-2 upload-incident">Max size limit : 100MB*</a>
					<span class="mb-0 d-flex justify-content-center upload-text-info" matTooltip="{{ fileTypes.join(', ') }}"
						matTooltipPosition="above">
						<ng-container *ngFor="let type of fileTypes; let last = last">
							<span>{{ type }}<span *ngIf="!last">, </span></span>
						</ng-container>
					</span>
				</span>
			</div>
			<div class="button-set">
			<button class="select" (click)="attachFile()"
				[disabled]="file === null">Attach</button>
		</div>
	</div>
</div>

<ng-template #errorDialog let-data>
	<h2 mat-dialog-title>Invalid file type</h2>
	<mat-dialog-content>{{ data }}</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-button mat-dialog-close color="primary">OK</button>
	</mat-dialog-actions>
</ng-template>